import React from 'react';
import { motion } from 'framer-motion';
import { images, PRICE } from '../data/content';
import { CtaButton } from './CtaButton';
import { TrustRow } from './TrustRow';
import { TennisBallIcon } from './TennisBallIcon';
export function Hero() {
  return <header className="relative isolate overflow-hidden bg-ink-900 pb-16 pt-10 sm:pb-24 sm:pt-14" data-id="element-98" data-mp="9ipaj6yed5y0">
      <img src={images.courtBg} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-[0.28]" data-id="element-99" data-mp="4jm53lei8xpi" />
      <div aria-hidden="true" className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_0%,rgba(37,89,232,0.35),transparent_60%)]" data-id="element-100" data-mp="xanpq20yvlgf" />
      <div aria-hidden="true" className="absolute inset-x-0 bottom-0 h-48 bg-ink-900/95" style={{
      paddingBottom: "44px"
    }} data-id="element-101" data-mp="s9zypgcqn4m7" />

      <div className="relative mx-auto max-w-6xl px-5" data-id="element-102" data-mp="neknkw647mth">
        <div className="flex justify-center" style={{
        paddingBottom: "6px",
        marginTop: "-20px",
        marginBottom: "-20px"
      }} data-id="element-103" data-mp="3d2le7pgobt71">
          <span className="inline-flex items-center gap-2 py-2 text-xs font-bold uppercase tracking-[0.2em] text-ball-400" data-id="element-104" data-mp="3j8ixl0k6uiv8">
            <TennisBallIcon className="h-4 w-4" data-id="element-105" data-mp="3o858h3cjnn0v" />
            Sigma Smart™
          </span>
        </div>

        <h1 className="mt-8 text-center font-display text-4xl uppercase leading-[0.95] text-white sm:text-6xl lg:text-7xl" style={{
        fontSize: "32px"
      }} data-id="element-106" data-mp="39b4gcyqfxq1v">
          El Sistema Operativo del Monitor de Pádel
          <span className="mt-3 block text-ball-400" data-id="element-107" data-mp="30gzwx0dmzgwd">Gestiona todas tus sesiones en 5 minutos</span>
        </h1>

        <p className="mx-auto mt-6 max-w-2xl text-center text-base leading-relaxed text-slate-300 sm:text-lg" style={{
        fontSize: "14px"
      }} data-id="element-108" data-mp="359j8jrsrk1yj">
          Planificaciones, técnica, táctica, negocio y seguimiento: todo listo para usar desde hoy.
          <span className="block text-court-200" data-id="element-109" data-mp="2hjf63nrba894">Sin improvisar. Sin perder tus fines de semana.</span>
        </p>

        <div className="mt-10 grid items-center gap-10 lg:grid-cols-[1.05fr_1fr]" data-id="element-110" data-mp="2lla52llrs9jq">
          <motion.div initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1]
        }} className="order-1 lg:order-1" data-id="element-111" data-mp="s1rqqjt21ys6">
            <img src={images.heroPack} alt="Padel Pro-Pack: el tomo principal junto a los 5 bonos — Padel Tracker Pro, WhatsApp Sales Scripts, Elite Court Checklist, Nutrition Guide y Video-Analysis Express — sobre una pista de pádel azul" className="mx-auto w-full max-w-xl rounded-2xl" style={{
            marginTop: "-25px",
            marginBottom: "-25px"
          }} data-id="element-112" data-mp="ia5j0xfxehu6" />
          </motion.div>

          <div className="order-2 flex flex-col items-center lg:order-2" data-id="element-113" data-mp="114suidug7dso">
            <CtaButton size="lg" href="#cierre" className="w-full max-w-md" data-id="element-114" data-mp="x0l5efk2vvtx">
              🎾 Quiero mi Pro-Pack ahora
            </CtaButton>
            <p className="mt-4 text-sm font-semibold text-slate-400" data-id="element-115" data-mp="3hrdacyaa5g1h">
              Precio normal <span className="line-through" data-id="element-116" data-mp="3htpzpwidasok">{PRICE.regular}</span> → hoy solo{' '}
              <span className="text-ball-400" data-id="element-117" data-mp="1xb5o89ocuje0">{PRICE.today}</span>
            </p>
          </div>
        </div>

        <TrustRow className="mt-12" data-id="element-118" data-mp="218tqjxsdnefx" />
      </div>
    </header>;
}